/**
 * @generated SignedSource<<02f611260d26163e6c797881fc049cbb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemFolderWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Folder_viewer">;
  readonly " $fragmentType": "ItemFolderWrapper_viewer";
};
export type ItemFolderWrapper_viewer$key = {
  readonly " $data"?: ItemFolderWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemFolderWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemFolderWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Folder_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "77f684fb88571417a0d748144a2ca67a";

export default node;
